import { createContext, useContext, useState, useCallback } from 'react';

// 创建 Context
interface HoverContextType {
  hoveredId: number | null;
  setHoveredId: (id: number | null) => void;
}

const HoverContext = createContext<HoverContextType>({
  hoveredId: null,
  setHoveredId: () => {},
});

// 创建 Provider 组件
const HoverProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [hoveredId, setHoveredId] = useState<number | null>(null);

  const handleSetHoveredId = useCallback((id: number | null) => {
    setHoveredId(id);
  }, []);

  return (
    <HoverContext.Provider value={{ hoveredId, setHoveredId: handleSetHoveredId }}>
      {children}
    </HoverContext.Provider>
  );
};

export { HoverProvider, HoverContext };
